module.exports = __webpack_public_path__ + "static/media/elements-header.4faf5053.png";